import { orderStatus } from '@/common/types'

type OrderStatusBadgeProps = {
    status: orderStatus | string
    children?: React.ReactNode
}

export function OrderStatusBadge({ status, children }: OrderStatusBadgeProps) {
    const statusMap: Record<string, { bg: string; textColor: string; label: string }> = {
        [orderStatus.CANCELLED]: {
            bg: 'bg-hover',
            textColor: 'text-content-secondary',
            label: 'Cancelled',
        },
        [orderStatus.COMPLETE]: {
            bg: 'bg-green-50',
            textColor: 'text-lime-800',
            label: 'Filled',
        },
        FILLED: {
            bg: 'bg-green-50',
            textColor: 'text-lime-800',
            label: 'Filled',
        },
        CANCELLING: {
            bg: 'bg-stone-50',
            textColor: 'text-content-secondary',
            label: 'Cancelling',
        },
        EXPIRED: {
            bg: 'bg-hover',
            textColor: 'text-content-secondary',
            label: 'Expired',
        },
        [orderStatus.FAILED]: {
            bg: 'bg-red-50',
            textColor: 'text-sentiment-bad',
            label: 'Failed',
        },
        [orderStatus['PARTIALLY FILLED']]: {
            bg: 'bg-green-50',
            textColor: 'text-lime-800',
            label: 'Partially filled',
        },
        [orderStatus['IN MARKET']]: {
            bg: 'bg-stone-50',
            textColor: 'text-content-secondary',
            label: 'Pending',
        },
        [orderStatus.REQUESTED]: {
            bg: 'bg-stone-50',
            textColor: 'text-content-secondary',
            label: 'Requested',
        },
    }

    const config = statusMap[status] || { bg: 'bg-stone-50', textColor: 'text-content-secondary', label: status }

    return (
        <div
            className={`px-2 py-1 ${config.bg} rounded-[100px] inline-flex flex-col justify-center items-center gap-2.5`}
        >
            <div className="inline-flex justify-start items-center gap-2">
                <div className={`justify-start ${config.textColor} text-sm font-medium font-['Inter'] leading-5`}>
                    {config.label}
                </div>
                {children}
            </div>
        </div>
    )
}
